import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import ChicletNumbers from './chiclet-numbers';
import Divider from '@material-ui/core/Divider';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

import { formatNumber } from '../../utils/common-utils';
import { DOMAIN_HIERARCHY_PARENT, DOMAIN_HIERARCHY_SUBDOMAIN } from '../../common/constants/definitions';

const styles = theme => ( {
    divider: {
        'grid-column': '1 / span 10'
    },
    gridContainer: {
        display: 'grid',
        'grid-row-gap': `${theme.spacing.unit * 1}px`,
        'grid-template-columns': 'repeat(10, 1fr)',
    },
    rowContent: {
        'grid-column-end': 'span 5'
    },
    rowTitle: {
        'grid-column': '1 / span 10'
    },
} );

const DomainManagementOverview = ( { classes, data, match } ) => {
    return (
        <div className={classes.gridContainer}>
            <div className={classes.rowTitle}>
                <Typography  variant="subtitle1">
                    {formatNumber( get( data, 'approved.totalCount', 0 ) )} Claimed Domains
                </Typography>
            </div>
            <div className={classes.rowContent}>
                <ChicletNumbers
                    automationId="domain-mgt-claimed-parent-domains"
                    bottom={`${formatNumber( get( data, 'approved.parentDomains.sendingCount', 0 ) )} sending`}
                    middle={formatNumber( get( data, 'approved.parentDomains.totalCount', 0 ) )}
                    path={`${match.url}/claimed-domains?domainHierarchy=${DOMAIN_HIERARCHY_PARENT}`}
                    top="Parent Domains"
                />
            </div>
            <div className={classes.rowContent}>
                <ChicletNumbers
                    automationId="domain-mgt-claimed-subdomains"
                    bottom={`${formatNumber( get( data, 'approved.subdomains.sendingCount', 0 ) )} sending`}
                    middle={formatNumber( get( data, 'approved.subdomains.totalCount', 0 ) )}
                    path={`${match.url}/claimed-domains?domainHierarchy=${DOMAIN_HIERARCHY_SUBDOMAIN}`}
                    top="Subdomains"
                />
            </div>
            <Divider className={classes.divider} />
            <div className={classes.rowTitle}>
                <Typography className={classes.rowTitle} variant="subtitle1">
                    {formatNumber( get( data, 'unclaimed.totalCount',0 ) )} Discovered Domains
                </Typography>
            </div>
            <div className={classes.rowContent}>
                <ChicletNumbers
                    automationId="domain-mgt-disc-parent-domains"
                    middle={formatNumber( get( data, 'unclaimed.parentDomains.totalCount', 0 ) )}
                    path={`${match.url}/discovered-domains?domainHierarchy=${DOMAIN_HIERARCHY_PARENT}`}
                    top="Parent Domains"
                />
            </div>
            <div className={classes.rowContent}>
                <ChicletNumbers
                    automationId="domain-mgt-claimed-subdomains"
                    middle={formatNumber( get( data, 'unclaimed.subdomains.totalCount', 0 ) )}
                    path={`${match.url}/discovered-domains?domainHierarchy=${DOMAIN_HIERARCHY_SUBDOMAIN}`}
                    top="Subdomains"
                />
            </div>
        </div>
    );
};
DomainManagementOverview.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.shape( {
        approved: PropTypes.object,
        unclaimed: PropTypes.object
    } ),
    match: PropTypes.shape( {
        url: PropTypes.string
    } ),
};


export default withStyles( styles )( DomainManagementOverview );
